import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { useMarket } from "Market/Providers/CurrentMarketProvider";
import { useManagerDiceOrderMutation } from "Order/Api/Mutation/managerDiceOrderMutation";
import { ActiveFiltersDisplay } from "Order/Components/ActiveFilters/ActiveFiltersDisplay";
import { useFilterCards } from "Order/Components/FilterCards";
import { ManagerDicePopup } from "Order/Components/ManagerDicePopup";
import { useOrderTable } from "Order/Components/Tables/Hooks/useOrdersListTable";
import { useOrderFilters } from "Order/Hooks/Filter/useOrderFilters";
import { OrderPaths } from "Order/Routes/Routing";
import { TopCardsSmall } from "Shared/Components/Cards/TopCardsSmall";
import { PageContainer } from "Shared/Components/Container";
import { Table } from "Shared/Components/Table";
import { Add, Casino } from "@mui/icons-material";
import { Box, Button, ButtonGroup, Typography } from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router";
import { FilterCurrentUserSwitch } from "../Components/FilterCurrentUserSwitch";
import { OrderFilterWidget } from "../Widgets/OrderFilterWidget";

const orderResource = Resources.base.order.shared;

export function OrdersPage() {
	const { t } = useResource();
	const navigate = useNavigate();
	const filter = useOrderFilters();
	const tableOptions = useOrderTable(filter);
	const filterCards = useFilterCards();
	const market = useMarket()?.market;
	const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
	const { mutate: managerDice } = useManagerDiceOrderMutation();

	const handleConfirmManagerDice = () => {
		market?.id && managerDice(market.id);
		setConfirmDialogOpen(false);
	};

	return (
		<PageContainer
			title={t(orderResource.title)}
			description={t(orderResource.description)}
		>
			<Box
				display="flex"
				flexDirection={{ xs: "column", md: "row" }}
				alignItems={{ xs: "flex-start", md: "center" }}
				justifyContent="space-between"
				gap={2}
				mb={3}
			>
				<Typography variant="h2" align="left">
					{t(orderResource.title)}
				</Typography>
				<TopCardsSmall cards={filterCards} />
				<Box display="flex" justifyContent="space-between">
					<FilterCurrentUserSwitch filter={filter} />
					<ButtonGroup
						size="small"
						variant="contained"
						aria-label="Basic button group"
					>
						<OrderFilterWidget />
						<Button
							title={t(orderResource.create)}
							onClick={() => navigate(OrderPaths.Create.route)}
						>
							<Add fontSize="small" />
						</Button>
					</ButtonGroup>

					{market && (
						<ButtonGroup size="small" variant="contained" sx={{ ml: 2 }}>
							<Button
								title={t(orderResource.assignManagers)}
								onClick={() => setConfirmDialogOpen(true)}
							>
								<Casino fontSize="small" />
							</Button>
						</ButtonGroup>
					)}
				</Box>
			</Box>

			<ActiveFiltersDisplay
				orderCount={tableOptions.rowCount}
				isLoading={tableOptions.state.isLoading}
			/>

			<Table tableOptions={tableOptions} />

			<ManagerDicePopup
				open={confirmDialogOpen}
				onConfirm={handleConfirmManagerDice}
				onClose={() => setConfirmDialogOpen(false)}
			/>
		</PageContainer>
	);
}
